<template>
  <v-card>
    <v-card-text>
      <v-layout row wrap justify-space-around>
        <v-flex sm5 xs12 class="pa-2">
          <div style="border: 1px solid grey; border-radius:20px;" class="pa-3">
            <v-layout row wrap align-center class="px-2">
              <v-flex sm6 xs12>
                <span style="font-size:20px;">Province list</span>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field
                  v-model="searchProvince"
                  prepend-inner-icon="search"
                  label="Search"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-list subheader>
              <v-list-tile
                v-for="(province, key) in searchProvinceData"
                :key="key"
                avatar
                @click="selectedProvince = province"
                :style="{
                  backgroundColor:
                    province == selectedProvince ? '#f9f9f9' : 'unset',
                }"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    province.province_name_th
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <!-- <vue-timepicker :minute-interval="15" class="weserve-timepicker"></vue-timepicker> -->
          </div>
        </v-flex>
        <v-flex sm6 xs12 class="pa-2">
          <service-list-manage :selectedProvince="selectedProvince" />
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import ServiceListManage from "@/components/back-office/ServiceManage/ServiceListManage.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      selectedProvince: {},
      searchProvince: "",
    };
  },
  components: {
    VueTimepicker,
    "service-list-manage": ServiceListManage,
  },
  computed: {
    ...mapState({
      provinceServiceData: (state) =>
        state.fetchProvinceBack.provinceServiceData,
    }),
    searchProvinceData() {
      return this.provinceServiceData.filter(
        (val) =>
          val.province_name_th.includes(this.searchProvince) ||
          this.searchProvince == ""
      );
    },
  },
  created() {
    this.$store.dispatch("fetchProvinceBack/getProvinceServiceList");
  },
};
</script>

<style scoped></style>
